import { Modal } from "react-bootstrap";
import FormInputs from "../../components/UI/FormInputs";
import { useState } from "react";
import WithRoutify from "../../hoc/WithRoutify";
import VisitsService from "../../services/VisitsService";
import { isObject, isSet } from "../../utils/commonUtils";
import WithRouter from "../../hoc/WithRouter";
import { useLocation } from "react-router-dom";
import FileManagerService from "../../services/FileManagerService";

const PdfResultContainer = (props) => {
    const { Loader } = props;
    const [formData, setFormData] = useState({});
    const [validation, setValidation] = useState({});
    const query = new URLSearchParams(useLocation().search);
    const [step, setStep] = useState(1);
    const isPhoneValidation = query.get("phone") == "true" ? true : false;
    const changeHandler = (fieldName, value) => {
        setValidation({ ...validation, [fieldName]: "" });
        setFormData({ ...formData, [fieldName]: value });
    };
    const submitHandler = async () => {
        const payload = {
            visit_id: query.get("visit_id"),
            result_type: query.get("result_type"),
            id: query.get("id"),
            patient: query.get("patient"),
            isPhoneValidation: isPhoneValidation,
            step: step,
            phone: formData.phone,
            email: formData.email,
            code: formData.code || "",
        };
        let updateValidation = { ...validation };
        Loader(true);
        const data = await VisitsService.getEmailPdfResult(payload);
        Loader(false);
        if (data.status && data.status === "ERROR") {
            if (isObject(data.data)) {
                for (let key in data.data) {
                    updateValidation = {
                        ...updateValidation,
                        [key]: data.data[key].join(","),
                    };
                }
            } else {
                props.Toast.error(data.data);
            }
            if (Object.keys(updateValidation).length > 0) {
                setValidation(updateValidation);
            }
        } else if (step == 2) {
            console.log("verification completed", data.data);
            const pdfData = {
                file_content: data.data,
                original_name: `${"name"}`,
                mime_type: "application/pdf",
            };
            FileManagerService.printPdf(pdfData);
            setStep(1);
            setFormData({});
        } else {
            setStep(step + 1);
        }
    };
    return (
        <div className="sh_login">
            <div className="sh_login-bleed">
                <main className="sh_login-bg">
                    <div className="container sh_login-container">
                        <div className="row justify-content-center">
                            <div className="col-12">
                                <div className="sh_login-hero text-center">
                                    <div className="sh_login-brand">SnapEHR</div>
                                    <div className="sh_login-title">A New Generation Has Arrived</div>
                                    <div className="sh_login-subtitle">
                                        Healthcare technology finally built for the way modern medicine works.
                                    </div>
                                </div>

                                <div className="d-flex justify-content-center">
                                    <div className="sh_login-card">
                                        <div className="sh_login-card-inner">
                                            <div className="sh_login-card-title">Verification</div>
                                            <div className="sh_login-card-subtitle">
                                                Confirm your identity to view your results
                                            </div>

                                            <form
                                                className="mt-3"
                                                onSubmit={(e) => {
                                                    e.preventDefault();
                                                    submitHandler();
                                                }}
                                            >
                                                {step === 1 ? (
                                                    <>
                                                        <FormInputs
                                                            type={isPhoneValidation ? "Phone" : ""}
                                                            className="form-control form-control-fields sh_login-control"
                                                            placeholder={
                                                                isPhoneValidation
                                                                    ? "Enter Phone Number"
                                                                    : "Enter Email Address"
                                                            }
                                                            name={isPhoneValidation ? "phone" : "email"}
                                                            changeHandler={(value) => {
                                                                changeHandler(
                                                                    isPhoneValidation ? "phone" : "email",
                                                                    value
                                                                );
                                                            }}
                                                            value={formData[isPhoneValidation ? "phone" : "email"]}
                                                        />
                                                        {isSet(
                                                            validation[
                                                                query.get("patient") == "true" ? "phone" : "email"
                                                            ]
                                                        ) !== "" ? (
                                                            <span className="text-danger m-1">
                                                                {isSet(
                                                                    validation[isPhoneValidation ? "phone" : "email"],
                                                                    ""
                                                                )}
                                                            </span>
                                                        ) : (
                                                            ""
                                                        )}
                                                        <div className="d-flex align-items-start mt-3 mb-2 text-muted">
                                                            <i className="fas fa-info-circle pt-2 fa-lg"></i>
                                                            <p className="font-weight-normal text-sm pl-2 mb-0">
                                                                {`Please enter your ${isPhoneValidation ? "phone number" : "email address"} to receive a verification code. This code will be used to verify your identity and secure your account.`}
                                                            </p>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <FormInputs
                                                            type=""
                                                            className="form-control form-control-fields sh_login-control"
                                                            placeholder="Enter Code"
                                                            name="code"
                                                            changeHandler={(value) => {
                                                                changeHandler("code", value);
                                                            }}
                                                            value={formData.code}
                                                        />
                                                        {isSet(validation.code, "") !== "" ? (
                                                            <span className="text-danger m-1">
                                                                {isSet(validation.code, "")}
                                                            </span>
                                                        ) : (
                                                            ""
                                                        )}
                                                        <div className="d-flex align-items-start mt-3 text-secondary">
                                                            <i className="fas fa-info-circle pt-2 fa-lg"></i>
                                                            <p className="font-weight-normal text-sm pl-2 mb-0">
                                                                {`Please check your ${isPhoneValidation ? "phone number" : "email address"} for the Verification Code and enter it above.`}
                                                            </p>
                                                        </div>
                                                    </>
                                                )}

                                                <button type="submit" className="btn sh_login-btn w-100 mt-2">
                                                    Submit
                                                </button>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};
export default WithRouter(WithRoutify(PdfResultContainer));